import Mob from './Mob'
import Chain from '../Chain/Chain'

/**
 * MuncherMob class
 *      - Mob that chases the mouse and consumes other mobs in its path
 */
export default class extends Mob {
    constructor (location, color) {
        super(location)
        this._mouthOpen = true
        this._color = color
        this._radius = 30
        this._tail = new Chain(this)
    }

    update (currentTime) {
        super.update()
        if (this.isAlive()) {
            this._animate(currentTime)
                ._chaseCursor(currentTime)
                ._consumeNearbyMobs()
        }
        this._tail.update(currentTime, this.isMoving())
        return this
    }

    draw () {
        this.game.getScene().writeText(
            this._mouthOpen ? '[ ]' : '[]',
            this.getX(),
            this.getY(),
            this._color,
        ).drawCirlce(
            this.getX(),
            this.getY(),
            this._radius,
            'rgba(255,255,255,0.3)',
        )
        return this
    }

    getTail () {
        return this._tail
    }

    _chaseCursor (currentTime) {
        if (currentTime % 15 === 0 || !this._lastKnownMousePosition) {
            this._lastKnownMousePosition = this.game.getMouse().getPosition()
        }
        this.moveTowards(this._lastKnownMousePosition)
        return this
    }

    _animate (currentTime) {
        if (currentTime % 30 === 0) {
            this._mouthOpen = !this._mouthOpen
        }
        return this
    }

    _consumeNearbyMobs () {
        if (this.isMoving()) {
            this.world.findObjects(this.getLocation(), this._radius)
                .forEach(object => {
                    if (object.isAlive() && object.getId() !== this.getId()) this._consume(object)
                    else if (!object.isAlive() && object.getId() !== this.getId()) this._checkPosion(object)
                })
        }
        return this
    }

    _consume (mob) {
        mob.die()
        this._tail.add(mob)
            .flashColor('rgba(255,255,255,1)', 25, 1)
        return this
    }

    _checkPosion (mob) {
        if (mob.isPoisonous()) {
            this.stop()
            this.die()
            this._tail.flashColor(`rgba(0,0,0,0)`, null, 10)
            this._tail.break()
        }
        return this
    }
}
